<script setup lang="ts">
  import { storeToRefs } from 'pinia';
  import { inject, ref } from 'vue';
  import { useSparepartStore } from '~/stores/sparepart';
  import CustomTable from './Base/CustomTable.vue';
  import CustomTextInput from './Base/CustomTextInput.vue';

  //variables
  const store = useSparepartStore();
  const { setArticleNumber, loadPollutants } = store;
  const { articleNumber, pollutants } = storeToRefs(store);
  const errorOccured = ref<boolean>(false);
  const createToast: any = inject('createToast');
  //methods
</script>

<template>
  <!-- ArticleNumber Input -->
  <CustomTextInput
    :value="articleNumber"
    type="articlenumber"
    @update-value="(_articleNumber: string) => setArticleNumber(_articleNumber)"
    @svhc-action-clicked="
      loadPollutants().catch((reason) => {
        createToast(null, $t('general.network-error'), 'error');
        console.log(reason);
      })
    "
  >
    <!-- Slot for inserting non input specific text -->
    <template #input-text>
      {{ $t('sparepart.articlenumber-input') }}
    </template>
  </CustomTextInput>

  <!-- Divider -->
  <hr :class="$gStyle('my-[36px]! h-0.5 border-t-0 bg-neutral-300')" />

  <!-- Table -->
  <CustomTable :data="pollutants" :error-occured="errorOccured" :serialnumber="articleNumber">
    <!-- Custom Table Header -->
    <template #custom-table-header>
      <patternlib-headline
        heading-tag="h6"
        :headline="$t('table.sku-text', { sku: articleNumber })"
        :class="$gStyle('mb-6')"
      />
    </template>

    <!-- Overview Content Table -->
    <patternlib-table-base>
      <!-- Table Header -->
      <tr slot="head">
        <th>{{ $t('general.articleNumber-text') }}</th>
        <th>{{ $t('general.article-text') }}</th>
        <th>{{ $t('general.substance-name') }}</th>
        <th>{{ $t('general.cas-number') }}</th>
      </tr>

      <!-- Table Content -->
      <patternlib-table-base-row v-for="pollutant in pollutants">
        <!-- Id -->
        <patternlib-table-base-cell noBorder id="articlenumber">{{
          pollutant.articleNumberPart
        }}</patternlib-table-base-cell>
        <!-- AttributeId -->
        <patternlib-table-base-cell noBorder id="articleQualifier">{{
          pollutant.productName
        }}</patternlib-table-base-cell>
        <!-- ColumnName -->
        <patternlib-table-base-cell noBorder id="substance">{{
          pollutant.substanceName
        }}</patternlib-table-base-cell>
        <!-- Description -->
        <patternlib-table-base-cell noBorder id="cas">{{
          pollutant.cas
        }}</patternlib-table-base-cell>
      </patternlib-table-base-row>
    </patternlib-table-base>
  </CustomTable>
</template>

<style scoped></style>
